module.exports = __webpack_public_path__ + "static/img/fail.c226be40.svg";